import router from "@/router";
import AuthService from "@/services/authService";
import { useAuthStore } from "@/stores/authStore";
import VeterinaryTokenService from "@/services/veterinaryTokenService";

export default function setupInterceptors(api) {
  api.interceptors.request.use(
    async config => {
      if (config.method === "patch") {
        config.headers["Content-Type"] = "application/merge-patch+json";
      }
      let effectiveToken = AuthService.getToken();
      if (VeterinaryTokenService.shouldUseVeterinaryToken(config.url)) {
        try {
          const veterinaryToken = await VeterinaryTokenService.getVeterinaryTokenAsync();
          if (veterinaryToken) {
            effectiveToken = veterinaryToken;
          } else {
            console.warn('[Interceptor] Token vétérinaire requis mais indisponible pour:', config.url);
          }
        } catch (error) {
          console.error('[Interceptor] Erreur lors de la récupération du token vétérinaire:', error);
        }
      }

      if (effectiveToken) {
        const isValid =
          effectiveToken === VeterinaryTokenService.getVeterinaryToken() && AuthService.isDelegue()
            ? VeterinaryTokenService.isVeterinaryTokenValid(effectiveToken)
            : AuthService.isTokenValid(effectiveToken);
        if (isValid) {
          config.headers.Authorization = `Bearer ${effectiveToken}`;
        } else {
          console.warn("Token expiré détecté lors de la requête");
          const authStore = useAuthStore();
          authStore.logout();
          return Promise.reject(new Error("Token expiré"));
        }
      }

      return config;
    },
    error => {
      return Promise.reject(error);
    }
  );

  api.interceptors.response.use(
    response => response,
    error => {
      const currentRoute = router.currentRoute.value;
      const authStore = useAuthStore();

      const publicRoutes = [
        "/login-veterinaire",
        "/login-proprietaire",
        "/login-delegue",
        "/inscription-proprietaire",
        "/forget-password-veterinaire",
        "/forget-password-proprietaire",
        "/",
      ];

      if (error.response?.status === 401 || error.response?.code === 401) {
        console.warn("Erreur 401: Token invalide ou expiré");

        if (!publicRoutes.includes(currentRoute.path)) {
          authStore.logout();
          console.info("Déconnexion automatique - Session expirée");
        }
      } else if (error.response?.status === 403 || error.response?.code === 403) {
        console.warn("Erreur 403: Accès interdit");

        if (!publicRoutes.includes(currentRoute.path)) {
          router.push("/dashboard");
        }
      }

      return Promise.reject(error);
    }
  );
}
